/**
 * Created by RSchweber-Koren on 10/18/2016.
 */

import angular from "angular";
import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import MainPageFooterController from "./MainPageFooterController";

const MainPageFooterComponent = {
    name: "tbMainPageFooter",
    config: {
        template: MainPageFooterController.template,
        controller: MainPageFooterController,
        controllerAs: MainPageFooterController.controllerAs
    },
    dependencies: DependencyListBuilder([
        MainPageFooterController.dependencies
    ])
};

export default angular
    .module(
        "trackerbase-app.views.main-page.tb-main-page-footer",
        MainPageFooterComponent.dependencies
    )
    .component(MainPageFooterComponent.name, MainPageFooterComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageFooter/index.js
// module id = lvG5
// module chunks = 1